import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CustomEncoderUtil } from '../../shared/utils/custom-encoder-util'

@Injectable()
export class EncodeHttpParamsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const params = new HttpParams({ encoder: new CustomEncoderUtil(), fromString: req.params.toString() })
        return next.handle(req.clone({ params }))
    }
}
